import { render, staticRenderFns } from "./popup_copy_access_rights.vue?vue&type=template&id=0049464e&scoped=true&"
import script from "./popup_copy_access_rights.vue?vue&type=script&lang=ts&"
export * from "./popup_copy_access_rights.vue?vue&type=script&lang=ts&"
import style0 from "./popup_copy_access_rights.vue?vue&type=style&index=0&id=0049464e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049464e",
  null
  
)

export default component.exports